import { Home, Wallet, Users, UserCog, Clock, FileText, ShieldCheck } from "lucide-react";

// Single source of truth for app features / access control.
export const FEATURES = [
    { key: "painel", label: "Painel Financeiro", path: "/", icon: Home },
    { key: "extrato", label: "Extrato & Despesas", path: "/extrato", icon: Wallet },
    { key: "colaboradores", label: "Colaboradores", path: "/colaboradores", icon: Users },
    { key: "gestores", label: "Gestores", path: "/gestores", icon: UserCog },
    { key: "ponto", label: "Cartões de Ponto", path: "/ponto", icon: Clock },
    { key: "relatorios", label: "Relatórios Diários", path: "/relatorios", icon: FileText },
    { key: "gestao_acessos", label: "Gestão de Acessos", path: "/acessos", icon: ShieldCheck },
];

export const MASTER_ONLY = ["gestao_acessos", "gestores"];
export const GRANTABLE = FEATURES.filter((f) => !MASTER_ONLY.includes(f.key));

export const hasFeature = (user, feature) => !!(user && (user.is_master || (user.permissions || []).includes(feature)));

export const firstRoute = (user) => {
    if (!user) return "/login";
    const f = FEATURES.find((x) => hasFeature(user, x.key));
    return f ? f.path : "/perfil";
};
